import { render, staticRenderFns } from "./StrGostergeGirisi.vue?vue&type=template&id=5d55a0de"
import script from "./StrGostergeGirisi.vue?vue&type=script&lang=js"
export * from "./StrGostergeGirisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports